import BigNumber from 'bignumber.js'
import { formatUSD } from './format'
BigNumber.config({ EXPONENTIAL_AT: 1e9 })
export const toFixed = (
  val: string | number | undefined,
  precision: number,
  mode: BigNumber.RoundingMode = BigNumber.ROUND_DOWN,
  trunkZero = true
) => {
  if (val === undefined) {
    return ''
  }

  if (!val && val !== 0) {
    return '' + val
  }
  if (Number.isNaN(precision)) {
    return '' + val
  }

  const sourceBigNum = new BigNumber('' + val)

  const dp = sourceBigNum.dp() || 0 // 有效数字小数位数

  if (trunkZero && dp <= precision) {
    return sourceBigNum.toFixed() // 避免补0
  } else {
    return sourceBigNum.toFixed(precision, mode)
  }
}

export const formatDayChangeRate = (oldVal?: number | string, newVal?: number | string): string => {
  const oldV = new BigNumber(oldVal || 0)
  const newV = new BigNumber(newVal || 0)
  let chgV
  if (oldV.isEqualTo(0)) {
    chgV = newV.isEqualTo(0) ? 0 : 100
  } else {
    chgV = newV.minus(oldV).dividedBy(oldV).multipliedBy(100).toNumber()
  }
  const symbol = chgV > 0 ? '+' : ''
  const percent = toFixed(chgV, 2) + '%'
  return symbol + percent
}

export const formatDayChangeAmount = (
  oldVal?: number | string,
  newVal?: number | string
): string => {
  const oldV = new BigNumber(oldVal || 0)
  const newV = new BigNumber(newVal || 0)
  const chgV = newV.minus(oldV).toNumber()
  const symbol = chgV > 0 ? '+' : ''
  const amount = formatUSD(chgV)
  return symbol + amount
}

export const getPrecison = (value: string | number) => {
  if (!value) {
    return 0
  }
  return value?.toString?.()?.split?.('.')?.[1]?.length || 0
}

export const toThousands = (num: string | number | BigNumber) => {
  const bn = new BigNumber(num)
  return bn.toFormat()
}
// 处理科学计数法
export const handleScientificNotation = (value: number | string) => {
  let x = new BigNumber(value)
  return x.toString()
}

export const resetToStartTime = (date: string) => {
  const clonedDate = new Date(date)
  clonedDate.setHours(0, 0, 0, 0)
  const formatData = new Date(clonedDate).getTime()
  return formatData
}

export const resetToEndTime = (date: string) => {
  const clonedDate = new Date(date)
  clonedDate.setHours(23, 59, 59)
  const formatData = new Date(clonedDate).getTime()
  return formatData
}
export const formatTime = (date: string) => {
  return new Date(date).getTime()
}

/**
 * 获取指定日期的第一秒的时间戳
 * @param date yyyy-MM-DD 形式的字符串
 */
export const getStartTimestampFromDate = (date: string) => {
  const startStr = date + ' 00:00:00'
  return new Date(startStr).getTime()
}

/**
 * 获取指定日期的最后一秒的时间戳
 * @param date yyyy-MM-DD 形式的字符串
 */
export const getEndTimestampFromDate = (date: string) => {
  const endStr = date + ' 23:59:59'

  return new Date(endStr).getTime()
}
